(() => {
      const init = () => document.querySelectorAll('[data-pdp-soil]').forEach((root) => {
        if (root.dataset.ready) return;
        const timing = window.LSSoilTiming, temperature = window.LSSoilTemperature;
        if (!timing || !temperature) return;
        root.dataset.ready = 'true';
        const profiles = JSON.parse(root.querySelector('[data-pdp-soil-profiles]').textContent || '[]');
        const el = {};
        ['badge','eyebrow','temperature','toggle','details','location','locationRow','change','message','scale','ideal','marker','recommendation','form','zip','error','headline','help'].forEach(key => {
          const attrKey = key.replace(/[A-Z]/g, letter => '-' + letter.toLowerCase());
          el[key] = root.querySelector('[data-pdp-soil-' + attrKey + ']');
        });
        const number = value => value === null || value === undefined || value === '' ? null : Number.isFinite(Number(value)) ? Number(value) : null;
        const friendlyTimingText = (rule, status) => {
          const activity = timing.normalize(rule?.activity);
          const isPreEmergent = activity === 'pre emergent';
          const isSeed = String(root.dataset.productType || '').includes('seed');

          if (isPreEmergent) {
            if (status === 'Excellent Conditions') return 'Now is a good time to apply pre-emergent.';
            if (status === 'Good Timing' || status === 'Approaching Window') return 'Good time to apply pre-emergent.';
            if (status === 'A Little Early') return 'A little early for pre-emergent.';
            if (status === 'Past Ideal Window') return 'The pre-emergent timing window has passed.';
            return 'Check pre-emergent timing for your area.';
          }

          if (isSeed) {
            if (status === 'Excellent Conditions') return 'Now is a good time to seed.';
            if (status === 'Good Timing' || status === 'Approaching Window') return 'Good time to seed.';
            if (status === 'A Little Early') return 'A little early to seed.';
            if (status === 'Past Ideal Window') return 'The ideal seeding window has passed.';
            return 'Check seeding conditions for your area.';
          }

          if (status === 'Excellent Conditions') return 'Now is a good time to apply.';
          if (status === 'Good Timing' || status === 'Approaching Window') return 'Good time to apply.';
          if (status === 'A Little Early') return 'A little early for this application.';
          if (status === 'Past Ideal Window') return 'The ideal application window has passed.';
          return 'Check local application timing.';
        };
        const states = { 'North Carolina':'NC', 'South Carolina':'SC', 'New York':'NY', 'Virginia':'VA', 'Tennessee':'TN', 'Georgia':'GA', 'Florida':'FL', 'Texas':'TX', 'California':'CA', 'Pennsylvania':'PA', 'Ohio':'OH', 'Maryland':'MD', 'New Jersey':'NJ', 'Kentucky':'KY', 'Alabama':'AL', 'Arkansas':'AR', 'Mississippi':'MS', 'Louisiana':'LA', 'Oklahoma':'OK', 'Missouri':'MO', 'Kansas':'KS', 'Illinois':'IL', 'Indiana':'IN', 'Michigan':'MI', 'Wisconsin':'WI', 'Minnesota':'MN', 'Iowa':'IA', 'Nebraska':'NE', 'Colorado':'CO', 'Connecticut':'CT', 'Delaware':'DE', 'Maine':'ME', 'Massachusetts':'MA', 'New Hampshire':'NH', 'Rhode Island':'RI', 'Vermont':'VT', 'West Virginia':'WV', 'Washington':'WA', 'Oregon':'OR', 'Idaho':'ID', 'Montana':'MT', 'Wyoming':'WY', 'Utah':'UT', 'Nevada':'NV', 'Arizona':'AZ', 'New Mexico':'NM', 'North Dakota':'ND', 'South Dakota':'SD', 'Alaska':'AK', 'Hawaii':'HI', 'District of Columbia':'DC' };
        const render = soil => {
          const average = number(soil.average);
          if (average === null) return;
          // Evaluate the same whole-degree temperature we show the customer.
          // This keeps edge cases consistent (for example, 75.4°F displays as 75°F
          // and should still count inside a 55–75°F ideal range).
          const displayAverage = Math.round(average);
          const selected = profiles.filter(rule => rule.enabled !== false && timing.seasonMatches(rule.season, new Date().getMonth()+1))
            .map(rule => ({rule, status:timing.evaluateRule(rule, displayAverage)})).filter(item => item.status)
            .sort((a,b) => Number(a.rule.sortOrder || 0)-Number(b.rule.sortOrder || 0))[0];
          if (el.temperature) { el.temperature.textContent = displayAverage + '°F'; el.temperature.hidden = false; }

          let resolvedLocation = soil.location || null;
          if (!resolvedLocation) {
            try {
              resolvedLocation = JSON.parse(localStorage.getItem('ls-soil-location-v1') || 'null');
            } catch (_) {}
          }

          const locationText = [
            resolvedLocation?.city,
            states[resolvedLocation?.state] || resolvedLocation?.state,
          ].filter(Boolean).join(', ') || (resolvedLocation?.zip ? `ZIP ${resolvedLocation.zip}` : '');

          if (el.location) {
            el.location.textContent = root.dataset.pdpSoilCompact === 'true'
              ? (locationText || 'Local conditions')
              : (locationText ? `${locationText} · 5-Day Avg` : '5-Day Avg');
          }
          if (root.dataset.pdpSoilCompact === 'true' && locationText) {
            root.classList.add('has-location');
            if (el.locationRow) el.locationRow.hidden = false;
            if (el.form) el.form.hidden = true;
          }
          if (el.scale) el.scale.hidden = true;
          if (el.recommendation) el.recommendation.textContent = '';
          if (!selected) {
            const inactiveRule = profiles.filter(rule => rule.enabled !== false)
              .sort((a,b) => Number(a.sortOrder || 0)-Number(b.sortOrder || 0))[0];
            const low = number(inactiveRule?.idealMin), high = number(inactiveRule?.idealMax);
            const inIdealRange = low !== null && high !== null && displayAverage >= low && displayAverage <= high;
            const ruleName = String(inactiveRule?.name || inactiveRule?.activity || 'This product').toLowerCase();
            const season = String(inactiveRule?.season || 'the appropriate season')
              .replace(/\s*\/\s*/g, ' through ')
              .toLowerCase();
            if (el.badge) { el.badge.textContent = 'Outside Timing Window'; el.badge.dataset.status = 'caution'; }
            if (root.dataset.pdpSoilCompact === 'true') {
              if (el.headline) {
                const activity = timing.normalize(inactiveRule?.activity);
                el.headline.textContent = activity === 'pre emergent'
                  ? 'Outside the recommended pre-emergent window.'
                  : String(root.dataset.productType || '').includes('seed')
                    ? 'Outside the recommended seeding window.'
                    : 'Outside the recommended application window.';
              }
              if (el.help) el.help.hidden = true;
            }
            if (el.message) {
              el.message.textContent = inIdealRange
                ? `Your soil temperature is in the ideal range, but ${ruleName} is recommended in ${season}. Plan for the next planting season.`
                : `${ruleName.charAt(0).toUpperCase() + ruleName.slice(1)} is recommended in ${season}. Plan for the next planting season.`;
              el.message.hidden = false;
            }
            return;
          }
          const {rule,status} = selected;
          const application = timing.normalize(rule.activity) === 'pre emergent';
          if (root.dataset.pdpSoilCompact === 'true') {
            if (el.headline) el.headline.textContent = friendlyTimingText(rule, status);
            if (el.help) el.help.hidden = true;
          }
          if (el.eyebrow) el.eyebrow.textContent = application ? 'LOCAL APPLICATION CONDITIONS' : 'LOCAL PLANTING CONDITIONS';
          if (el.badge) {
            el.badge.textContent = status === 'Excellent Conditions' ? 'IDEAL' : status;
            el.badge.dataset.status = status === 'Excellent Conditions' ? 'ideal' : 'caution';
          }
          if (el.message) {
            el.message.textContent = timing.messageFor(rule,status);
            el.message.hidden = !el.message.textContent;
          }
          let low = number(rule.idealMin), high = number(rule.idealMax);
          const recommendedLow = number(rule.recommendationStart), recommendedHigh = number(rule.recommendedMax);
          let label = 'Recommended for ' + root.dataset.productName;
          if (application) {
            const target = number(rule.targetThreshold), start = number(rule.recommendationStart);
            if (target !== null) {
              const cooling = timing.normalize(rule.trend) === 'cooling';
              low = cooling ? target : (start ?? target-10);
              high = cooling ? Math.max(start ?? target+10, displayAverage+5, target+10) : target;
              label = 'Apply before soil ' + (cooling ? 'cools' : 'warms') + ' to ' + target + '°F';
            }
          }
          if (low !== null && high !== null && high > low) {
            const axisMin = Math.floor((Math.min(low,recommendedLow ?? low,displayAverage)-10)/10)*10;
            const axisMax = Math.ceil((Math.max(high,recommendedHigh ?? high,displayAverage)+10)/10)*10;
            // The existing fall rule has a lower threshold, not an upper temperature limit.
            if(application && timing.normalize(rule.season)==='fall') high = axisMax;
            const percent = value => Math.max(0,Math.min(100,100*(value-axisMin)/(axisMax-axisMin)));
            if (el.scale && el.ideal && el.marker) {
              el.ideal.style.left = percent(low)+'%';
              el.ideal.style.width = (percent(high)-percent(low))+'%';
              el.marker.style.left = percent(displayAverage)+'%';
              el.scale.querySelectorAll('.ls-pdp-soil__scale-values span').forEach((tick,i) => tick.textContent = Math.round(axisMin+(axisMax-axisMin)*i/4)+'°');
              const labels = el.scale.querySelectorAll('.ls-pdp-soil__scale-labels span');
              labels[0].textContent = application ? (timing.normalize(rule.trend)==='cooling' ? 'Past Window' : 'Early') : 'Too Cool';
              labels[1].textContent = application ? 'Application Window' : 'Ideal Range';
              labels[2].textContent = application ? (timing.normalize(rule.trend)==='cooling' ? 'Warmer Soil' : 'Past Window') : 'Too Warm';
              el.scale.hidden = false;
            }
            if (el.recommendation) el.recommendation.textContent = application ? label : recommendedLow !== null && recommendedHigh !== null ? label + ': ' + recommendedLow + '–' + recommendedHigh + '°F · Ideal: ' + low + '–' + high + '°F' : label + ': ' + low + '–' + high + '°F';
          }
        };
        const load = async location => {
          try {
            const soil = await temperature.loadForLocation(location);
            const payload = {...soil,location};
            window.LSSoilData = payload;
            window.dispatchEvent(new CustomEvent('ls:soil-data',{detail:payload}));
          } catch(error) {
            if (el.location) el.location.textContent = error.message;
            if (el.badge) el.badge.textContent = 'UNAVAILABLE';
          }
        };
        el.toggle?.addEventListener('click', () => {
          const expanded = el.toggle.getAttribute('aria-expanded') !== 'true';
          el.toggle.setAttribute('aria-expanded', String(expanded));
          el.toggle.setAttribute('aria-label', (expanded ? 'Collapse' : 'Expand') + ' soil temperature details');
          root.dataset.expanded = String(expanded);
          if (el.details) el.details.hidden = !expanded;
        });
        el.change?.addEventListener('click', () => {
          if (!el.form) return;
          const compactMode = root.dataset.pdpSoilCompact === 'true';
          if (compactMode) {
            root.classList.remove('has-location');
            el.form.hidden = false;
            if (el.locationRow) el.locationRow.hidden = true;
            if (el.temperature) el.temperature.hidden = true;
            if (el.headline) {
              el.headline.textContent = String(root.dataset.productType || '').includes('seed')
                ? 'Check planting conditions'
                : 'Check application conditions';
            }
            if (el.help) {
              el.help.hidden = false;
              el.help.textContent = String(root.dataset.productType || '').includes('seed')
                ? 'Enter your ZIP code to check local timing.'
                : 'Enter your ZIP code to check local timing.';
            }
          } else {
            el.form.hidden = !el.form.hidden;
          }
          if(!el.form.hidden) el.zip?.focus();
        });
        el.form?.addEventListener('submit', async event => {
          event.preventDefault();
          try {
            const location = await temperature.geocodeZip(el.zip.value);
            await load(location);
            localStorage.setItem('ls-soil-location-v1',JSON.stringify(location));
            el.zip?.blur();
            if (el.form) el.form.hidden = true;
            el.error.hidden = true;
          } catch(error) {
            if (el.error) { el.error.textContent = error.message; el.error.hidden = false; }
          }
        });
        window.addEventListener('ls:soil-data',event => render(event.detail));
        if(number(window.LSSoilData?.average) !== null) render(window.LSSoilData);
        else {
          try {
            const saved = JSON.parse(localStorage.getItem('ls-soil-location-v1') || 'null');
            if (saved) {
              if (el.zip && saved.zip) el.zip.value = saved.zip;
              load(saved);
            } else if (el.badge) {
              el.badge.textContent = root.dataset.pdpSoilCompact === 'true' ? 'Enter ZIP' : 'Check Local Timing';
            }
          } catch(error) {}
        }
      });
      if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
      document.addEventListener('shopify:section:load', init);
    })();
